import React from 'react';
import './Counselling.css';


const Counselling = () => {
  return (
    <section className="counselling-section" id='services'>
      <div className="container text-dark text-center">
        <h2 className="section-title">COUNSELLING</h2>
        <p className="section-subtitle">
          We at <strong>Nasha Mukti Kendra Mandi</strong>  provide best counselling sessions for our patients for their treatment and the process that should be followed.We not only help them minimize their dependency but also improve their overall lifestyle
        </p>
        <div className="dot-divider mx-auto"></div>

        <div className="row mt-5">
          <div className="col-md-4 mb-4" data-aos="fade-up">
            <img src="/assets/therepy.jpg" alt="Therapy" className=" rounded service-img" />
            <h5 className="mt-3">Therapy</h5>
            <p>We at <strong>Nasha Mukti Kendra Mandi</strong> offer therapy using medical, herbal, and Ayurvedic methods. These natural approaches help patients heal from within and restore balance using the body’s own recovery abilities.</p>
          </div>
          <div className="col-md-4 mb-4" data-aos="fade-up">
            <img src="/assets/yoga.jpg" alt="Yoga" className=" rounded service-img" />
            <h5 className="mt-3">Yoga & Meditation</h5>
            <p>At our <strong>Rehabilitation Centre in Mandi</strong> we emphasize on Yoga and meditation sessions that strengthen the mind. They help reduce cravings and improve focus, enabling patients to gain better control over their thoughts and daily behaviors at <strong>Nasha Mukti Kendra in Mandi</strong> .</p>
          </div>
          <div className="col-md-4 mb-4" data-aos="fade-up">
            <img src="/assets/steps.jpeg" alt="12 Step Program" className=" rounded service-img" />
            <h5 className="mt-3">12 Step Program</h5>
            <p>At our <strong>Rehabilitation Centre in Mandi</strong> we follow our 12-step program that guides patients through all recovery phases — from awareness to lasting change. Each step supports emotional healing, personal growth, and long-term sobriety.</p>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-4 mb-4" data-aos="fade-up">
            <img src="/assets/symptom.jpg" alt="Symptoms" className=" rounded service-img" />
            <h5 className="mt-3">Symptoms</h5>
            <p>Understanding and treating symptoms early is crucial. Patients may act irrationally and lose control. Identifying these signs helps ensure safety for themselves and others around them.</p>
          </div>
          <div className="col-md-4 mb-4" data-aos="fade-up">
            <img src="/assets/family.jpg" alt="Family" className=" rounded service-img" />
            <h5 className="mt-3">Family Program</h5>
            <p>We at <strong>Nasha Mukti Kendra Mandi</strong> involve families in the healing process. Their support and acceptance play a key role in building emotional strength and long-term success during a patient’s recovery journey.</p>
          </div>
          <div className="col-md-4 mb-4" data-aos="fade-up">
            <img src="/assets/exercising.jpg" alt="Exercise" className=" rounded service-img" />
            <h5 className="mt-3">Exercises</h5>
            <p>Our team at  Rehabilitation Centre in Mandi Himachal Pradesh treats physical activity to build stamina and supports recovery. We design exercise routines that boost mental and physical health, helping patients feel more energized and resilient daily.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counselling;
